export default {
  title: "Associated companies",

  table: {
    noData: "No associated companies yet",
  },

  input: {
    title: "{{action}} company association",
    company: "Company",
    type: "Type",
  }
}
